// lib
import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
// src
import CarouselWrapper, { CarouselWrapperProps } from '../CarouselLayout';
import {
  CardMarketingProperty,
  LibCardMarketingPropertyProps
} from '../../components/CardMarketingProperty';
// styles&utils
import styles from './styles';

export interface LibMarketingPropertyCardSectionProps {
  variant?: CarouselWrapperProps['variant'];
  richTextTitle?: string;
  propertyCardsData: {
    cardHref: LibCardMarketingPropertyProps['CardHref'];
    title: LibCardMarketingPropertyProps['title'];
    price: LibCardMarketingPropertyProps['price'];
    description: LibCardMarketingPropertyProps['description'];
    propertyImage: {
      image: LibCardMarketingPropertyProps['propertyImage']['image'];
      alt: LibCardMarketingPropertyProps['propertyImage']['alt'];
    };
  }[];
  numberOfCardsPerRow?: number;
}

function LibMarketingPropertyCardSection({
  variant = 'white',
  richTextTitle = '',
  propertyCardsData,
  numberOfCardsPerRow = 4
}: LibMarketingPropertyCardSectionProps) {
  const { breakpoints } = useTheme();
  const mobileScreen = useMediaQuery(breakpoints.down('md'));

  const [newArray, setNewArray] = React.useState(propertyCardsData);

  React.useEffect(() => {
    if (propertyCardsData.length <= numberOfCardsPerRow) {
      if (!mobileScreen) {
        const newArr = [...propertyCardsData];

        const remaining = numberOfCardsPerRow - propertyCardsData.length;

        for (let i = 0; i < remaining; i += 1) {
          newArr.push(null);
        }

        setNewArray([...newArr]);
      } else {
        setNewArray([...propertyCardsData]);
      }
    }
  }, [mobileScreen]);

  return (
    <CarouselWrapper
      className="MarketingPropertyCardSection"
      sx={styles.carouselWrapper}
      variant={variant}
      richTitle={richTextTitle}
      type="cards"
      noOfCardsLg={numberOfCardsPerRow}
      isInfinite={
        propertyCardsData.length > numberOfCardsPerRow || mobileScreen
      }
    >
      {newArray.map((item, idx) =>
        !item?.title ? (
          <Box key={idx} />
        ) : (
          <Box key={idx} sx={styles.foxtonsTeam}>
            <CardMarketingProperty
              CardHref={item.cardHref}
              title={item.title}
              price={item.price}
              description={item.description}
              propertyImage={{
                image: item?.propertyImage?.image || '',
                alt: item?.propertyImage?.alt || ''
              }}
            />
          </Box>
        )
      )}
    </CarouselWrapper>
  );
}

export const MarketingPropertyCardSection = React.memo(
  LibMarketingPropertyCardSection
);

export default MarketingPropertyCardSection;
